import React from 'react';
import { Button, message } from 'antd';
import { Copy } from 'lucide-react';
import styles from './styles.module.css';
import * as translations from '../strings';
import { getLangKey } from 'appJS/models/Language';

const strings = translations[getLangKey()];

type Props = {
  bugherdUrl: string;
  apiKey: string;
};

export const CodeBlock = ({ bugherdUrl, apiKey }: Props) => {
  const tagName = 'script';
  const atts = {
    type: 'text/javascript',
    src: `${bugherdUrl}/sidebarv2.js?apikey=${apiKey}`,
    async: 'true'
  };

  const scriptSrc = `<${tagName} ${Object.entries(atts)
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ')}></${tagName}>`;

  const parts = [
    '<',
    <span className={styles.tagName}>{tagName}</span>,
    ...Object.entries(atts).map(([key, value]) => (
      <>
        <span className={styles.key}>{` ${key}`}</span>="
        <span className={styles.value}>{value}</span>"
      </>
    )),
    '></',
    <span className={styles.tagName}>{tagName}</span>,
    '>'
  ];

  return (
    <div className={styles.codeBlock}>
      <p className={styles.code}>{parts}</p>
      <Button
        className={styles.copyButton}
        onClick={() => {
          navigator.clipboard.writeText(scriptSrc);
          message.success(strings.copiedToClipboard(true));
        }}
        type="text"
        icon={<Copy size={16} />}
      >
        {strings.copy}
      </Button>
    </div>
  );
};
